<template>
  <div>
    <v-dialog
      v-model="showDialog"
      width="700"
      persistent
    >
      <v-card v-if="showDialog">
        <v-toolbar
          dark
          dense
          color="pink"
        >
          <v-toolbar-title>
            {{ title }}
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon
              @click.native="showDialog = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text
          class="dialog-conente-scroll"
          style="height: calc(80vh - 108px);"
        >
          <!-- Tab 选择 -->
          <template v-if="!propTrackingNo">
            <v-tabs
              v-model="createType"
              color="transparent"
              active-class="blue--text v-tabs__item--active"
            >
              <v-tabs-slider color="blue" />
              <v-tab
                href="#single"
                class="px-3 subheading max-width-auto"
              >
                <b>單獨登記</b>
              </v-tab>
              <v-tab
                href="#multiple"
                class="px-3 subheading max-width-auto"
              >
                <b>批量登記</b>
              </v-tab>
            </v-tabs>
            <v-divider class="mb-2" />
          </template>

          <v-form
            ref="form"
            @submit.prevent
          >
            <!-- 显示包裹信息 -->
            <div
              v-if="propTrackingNo"
              class="pb-2"
            >
              <div
                v-if="!parcel.pclid"
                class="py-2 title"
              >
                {{ propTrackingNo }}
              </div>
              <div
                v-else
                class="py-2"
              >
                <KImg
                  v-if="parcel.carrier"
                  :src="`/static/images/carrier/${parcel.carrier}.png`"
                  width="20"
                />
                <span
                  v-if="parcel.carrierName"
                  class=""
                >{{ parcel.carrierName }}</span>

                <template v-if="parcel.isStorage">
                  {{ parcel.trackingNo }}
                </template>
              </div>
              <v-layout
                v-if="parcel.extraInfo?.tpTaobaoTradeItems?.length"
                class="mx-0 pb-2"
              >
                <div>
                  <KImg
                    v-if="parcel.extraInfo.tpTaobaoTradeItems.length"
                    :src="parcel.extraInfo.tpTaobaoTradeItems[0].itemPic"
                    width="60"
                  />
                  <KImg
                    v-else-if="parcel.extraInfo.snapshotsEs&&parcel.extraInfo.snapshotsEs.length"
                    :src="parcel.extraInfo.snapshotsEs[0] | upyun('!/fh/68')"
                    width="60"
                    @click.native="viewImg(parcel.extraInfo.snapshotsEs)"
                  />
                  <KImg
                    v-else
                    :src="''"
                    width="60"
                  />
                </div>
                <v-flex
                  class="ml-2 pa-0"
                >
                  <div
                    v-if="parcel.extraInfo.tpTaobaoTradeItems.length"
                    class="line-clamp-2"
                  >
                    {{ parcel.extraInfo.tpTaobaoTradeItems[0].itemName }}
                  </div>
                  <div v-if="parcel.weight > 0">
                    包裹重量
                    <span
                      class="blue--text mr-1"
                      style=""
                    >{{ parcel.weight | toKg }}</span>KG
                  </div>
                </v-flex>
              </v-layout>
              <v-divider class="my-2" />
            </div>

            <!-- Step 1: 输入运单号 -->
            <template v-if="step === 1">
              <Step1Single
                v-if="createType === 'single'"
                v-model="model.trackingNo"
                :disabled="!!propTrackingNo"
                @confirm="toStep(2)"
              />

              <Step1Multiple
                v-if="createType === 'multiple'"
                v-model="model.tnosRel"
                :step="step"
                @confirm="toStep(2)"
              />

              <!-- 使用说明 -->
              <v-alert
                :value="true"
                type="warning"
                border="left"
                elevation="1"
                colored-border
                class="body-2 "
                outline
              >
                此功能適用於：<br>
                1.賣家補發包裹，單號未登記於淘寶/阿里巴巴<br>
                2.賣家登記的單號有誤<br>
                3.幫朋友郵寄，無法登入淘寶帳戶導入商品
              </v-alert>

              <div class="mt-2 text-center">
                <img
                  src="https://static.kkren.com.tw/static/images/attachTrackingNo-teaching.png"
                  width="400"
                >
              </div>
            </template>

            <!-- 显示运单号 -->
            <div
              v-if="step > 1"
              class="pb-2"
            >
              <v-card
                outlined
                class="pa-3 mb-3"
              >
                <v-layout align-center>
                  <v-flex>
                    <div class="caption grey--text">
                      運單號
                    </div>
                    <div class="subtitle-1 font-weight-medium">
                      {{ displayTrackingNo }}
                    </div>
                  </v-flex>
                  <v-btn
                    v-if="!propTrackingNo"
                    icon
                    small
                    @click="step = 1"
                  >
                    <v-icon size="20">
                      edit
                    </v-icon>
                  </v-btn>
                </v-layout>
              </v-card>
            </div>

            <!-- Step 2: 选择商品类型和输入商品信息 -->
            <template v-if="step === 2">
              <Step2ImageSearch
                v-if="inputType === 'imageSearch'"
                :parcel="parcel"
                :item-qty.sync="model.itemQty"
                :memo.sync="model.memo"
                :error-msg="errorMsg"
                @item-changed="onItemChanged"
                @change-input-type="inputType = $event"
                @error="errorMsg = $event"
              />

              <Step2GoodsSearch
                v-if="inputType === 'goodsSearch'"
                :parcel="parcel"
                :item-qty.sync="model.itemQty"
                :memo.sync="model.memo"
                @item-changed="onItemChanged"
                @change-input-type="inputType = $event"
              />

              <Step2GoodsUrl
                v-if="inputType === 'goodsUrl'"
                :parcel="parcel"
                :tracking-no="model.trackingNo"
                :disabled="model.pclid && model.trackingNo.length > 0"
                :loading-submit="loadingSubmit"
                @goods-fetched="onGoodsFetched"
                @change-input-type="inputType = $event"
              />
            </template>

            <!-- Step 3: 填写商品数量和单价 -->
            <template v-if="step === 3">
              <Step3PriceForm
                :parcel="parcel"
                :chose-item="choseItem"
                :goods-data-list="goodsDataList"
                :item-qty.sync="model.itemQty"
                :item-price.sync="model.itemPrice"
                :memo.sync="model.memo"
              />
            </template>
          </v-form>
        </v-card-text>

        <!-- 移除了 Step 2 底部按钮，选择商品后自动跳转到 Step3 -->

        <v-card-actions v-if="step === 2 && inputType === 'goodsSearch'">
          <v-spacer />
          <v-btn
            v-if="!choseItemid && operationType !== 'updateCid' && !propModel.updateCidByPlatForm"
            flat
            class="blue--text"
            @click="inputType = 'goodsUrl'"
          >
            <u>您也可以由此直接貼上淘寶商品網址</u>
          </v-btn>
          <v-spacer />
        </v-card-actions>
        <!-- Step 3 底部按钮 -->
        <v-card-actions v-if="step === 3">
          <v-spacer />
          <v-btn
            :disabled="!model.itemQty || !model.itemPrice"
            :loading="loadingSubmit"
            color="info"
            large
            class="pa-4"
            @click="submitStep3"
          >
            送出
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as storageUtils from '@g/utils/storageUtils'

import Step1Single from './Step1Single.vue'
import Step1Multiple from './Step1Multiple.vue'
import Step2GoodsSearch from './Step2GoodsSearch.vue'
import Step2ImageSearch from './Step2ImageSearch.vue'
import Step2GoodsUrl from './Step2GoodsUrl.vue'
import Step3PriceForm from './Step3PriceForm.vue'

export default {
  components: {
    Step1Single,
    Step1Multiple,
    Step2GoodsSearch,
    Step2ImageSearch,
    Step2GoodsUrl,
    Step3PriceForm
  },
  props: {
    // 切换 dialog 的显示
    propShowForm: {
      type: Boolean
    },
    propModel: Object,
    operationType: String,
    tiid: String
  },
  data () {
    return {
      createType: 'single',
      showDialog: this.propShowForm,
      step: 1,
      inputType: 'goodsSearch', // imageSearch | goodsSearch | goodsUrl
      model: {
        trackingNo: '',
        tnosRel: '',
        tradeid: '',
        itemQty: '1',
        itemPrice: '',
        memo: ''
      },
      tnosRelArr: [],
      loadingSubmit: false,

      // 选中的商品
      choseItem: null,
      goodsData: null,
      goodsDataList: [],

      errorMsg: ''
    }
  },
  computed: {
    choseItemid () {
      return this.choseItem ? this.choseItem.id || this.choseItem.itemid : ''
    },
    title () {
      if (this.propTrackingNo) {
        return '請告訴我這是什麼'
      }
      return '登記包裹'
    },
    propTrackingNo () {
      if (this.parcel) {
        return this.parcel.trackingNoPri || this.parcel.trackingNo
      }
      return ''
    },
    parcel () {
      return this.propModel
    },
    // 显示的运单号
    displayTrackingNo () {
      if (this.createType === 'single') {
        return this.model.trackingNo
      } else {
        // 批量登记显示所有运单号
        if (this.tnosRelArr.length > 0) {
          return this.tnosRelArr.length > 3
            ? `${this.tnosRelArr.slice(0, 3).join(', ')} 等${this.tnosRelArr.length}個`
            : this.tnosRelArr.join(', ')
        }
        return this.model.tnosRel.replace(/\n/g, ', ').trim()
      }
    }
  },
  watch: {
    propShowForm: function (newValue) {
      this.showDialog = newValue
      if (this.showDialog) {
        this.resetForm()
        if (this.propTrackingNo) {
          this.model.trackingNo = this.propTrackingNo
          this.step = 2
          this.showTrackingNoTips()
        } else {
          this.model.trackingNo = ''
          this.step = 1
        }
      }
    },
    showDialog: function (newValue) {
      this.$emit('update:propShowForm', newValue)
    },
    createType () {
      this.step = 1
    }
  },
  methods: {
    resetForm () {
      this.createType = 'single'
      this.inputType = 'goodsSearch'
      this.goodsData = null
      this.choseItem = null
      this.goodsDataList = []
      this.errorMsg = ''
    },

    showTrackingNoTips () {
      if (!localStorage.AttachTrackingNoTips) {
        setTimeout(() => {
          this.$confirm(`
            <h4>品名需如實申報，若有謊報會停止帳號使用權利。</h4>
            登記包裹時，請特別注意品名需如實申報，若發現有謊報品名衝關，我們將停止該帳號所有申報人和收件人的使用權利，巧巧郎關心您。
          `, {
            buttonFalseText: '',
            buttonTrueText: '知道了'
          })
          localStorage.AttachTrackingNoTips = '1'
        }, 300)
      }
    },

    toStep (step) {
      this.step = step
      if (step === 2 && this.createType === 'multiple') {
        this.tnosRelArr = this.model.tnosRel.split('\n')
          .map(item => item.trim())
          .filter(item => item.length)
      }
    },

    onItemChanged (item) {
      this.choseItem = item
      // 选择商品后自动跳转到 step3
      if (item) {
        this.step = 3
      }
    },

    onGoodsFetched (goodsData) {
      this.goodsData = goodsData
      if (goodsData && goodsData.items) {
        this.goodsDataList = goodsData.items
        // 获取商品后自动跳转到 step3
        this.step = 3
      }
    },

    submitStep3 () {
      // 根据选择的商品类型调用对应的提交方法
      if (this.choseItem) {
        this.submitTaobao()
      } else if (this.goodsDataList.length > 0) {
        this.submit()
      }
    },

    async submit () {
      try {
        this.loadingSubmit = true
        if (!this.$refs.form.validate()) {
          return
        }
        const params = {
          memo: this.model.memo,
          itemid: this.goodsDataList[0].itemid,
          itemQty: this.model.itemQty || 1,
          itemCid: this.goodsDataList[0].itemCid,
          itemName: this.goodsDataList[0].itemName,
          itemPic: this.goodsDataList[0].itemPic,
          price: this.model.itemPrice || this.goodsDataList[0].itemFinalPrice,
          platform: this.goodsDataList[0].platform || 'taobao',
          tradeProp: this.parcelAmount > 0
            ? undefined
            : {
                itemPrice: this.model.itemPrice,
                itemQty: this.model.itemQty,
                trpLics: []
              }
        }
        if (this.createType === 'single') {
          params.trackingNo = this.model.trackingNo
        } else {
          params.trackingNo = this.tnosRelArr.join(',')
        }
        let res
        if (this.propModel.updateCidByPlatForm || this.operationType === 'updateCid') {
          let tiid = this.tiid
          if (!tiid) {
            const tpItem = this.propModel.extraInfo.tpTaobaoTradeItems.find(tpItem => tpItem.needUpdateCid)
            tiid = tpItem.tiid
          }
          res = await this.$store.dispatch('tpsp/tpttItem/updateCidRelcid', {
            tiid,
            itemId: this.goodsData.items[0].itemid,
            title: this.goodsData.items[0].itemName,
            categoryId: this.goodsData.items[0].itemCid
          })
        } else {
          res = await this.$store.dispatch('tpTaobaoTrade/attachTrackingNoItemId', params)
        }
        if (!res.data.error || res.data.error === 'DG1688ItemExists' || res.data.error === 'DG1688TaobaoItemExists') {
          this.closeDialog()
          this.$emit('reload')
        } else {
          this.showError(res, params)
        }
      } finally {
        this.loadingSubmit = false
      }
    },

    async submitTaobao () {
      try {
        this.loadingSubmit = true
        if (!this.$refs.form.validate()) {
          return
        }
        const params = {
          memo: this.model.memo,
          itemid: this.choseItemid,
          itemQty: this.model.itemQty,
          itemCid: this.choseItem.itemCid || this.choseItem.category,
          itemName: this.choseItem.title,
          itemPic: this.choseItem.pic_url || this.choseItem.imageUrls[0],
          price: this.model.itemPrice || this.choseItem.price,
          platform: this.choseItem.isTmall ? 'tmall' : 'taobao',
          tradeProp: this.parcelAmount > 0
            ? undefined
            : {
                itemPrice: this.model.itemPrice,
                itemQty: this.model.itemQty,
                trpLics: []
              }
        }
        if (this.createType === 'single') {
          params.trackingNo = this.model.trackingNo
        } else {
          params.trackingNo = this.tnosRelArr.join(',')
        }
        let res
        if (this.propModel.updateCidByPlatForm || this.operationType === 'updateCid') {
          let tiid = this.tiid
          if (!tiid) {
            const tpItem = this.propModel.extraInfo.tpTaobaoTradeItems.find(tpItem => tpItem.needUpdateCid)
            tiid = tpItem.tiid
          }
          res = await this.$store.dispatch('tpsp/tpttItem/updateCidRelcid', {
            tiid,
            itemId: this.choseItemid,
            title: this.choseItem.title || this.choseItem.itemName,
            categoryId: this.choseItem.itemCid || this.choseItem.category
          })
        } else {
          res = await this.$store.dispatch('tpTaobaoTrade/attachTrackingNoItemId', {
            params,
            options: {
              noShowError: true,
              retry: 0
            }
          })
        }
        if (!res.data.error || res.data.error === 'DG1688ItemExists' || res.data.error === 'DG1688TaobaoItemExists') {
          this.closeDialog()
          this.$emit('reload')
        } else {
          this.showError(res, params)
        }
      } finally {
        this.loadingSubmit = false
      }
    },

    closeDialog () {
      this.showDialog = false
      this.step = 1
      this.model = {
        trackingNo: '',
        tnosRel: '',
        tradeid: '',
        memo: '',
        itemQty: '1',
        itemPrice: ''
      }
      this.choseItem = null
      this.goodsData = null
      this.goodsDataList = []
    },

    async showError (res, params) {
      if (res.data.error === 'UidExists' || res.data.error === 'ParcelTradeUidConflict') {
        if (String(res.data.extras.uid) === '3') {
          this.$snackbar('包裹超過倉儲期限，已被倉庫清理或銷毀')
          return
        }
        if (!await this.$confirm(`${params.trackingNo} 包裹已由會員編碼 ${res.data.extras.uid} 登記，如果這是您的包裹，而您不認識這個帳號請與客服聯絡。`, {
          buttonTrueText: '是我認識的帳號',
          buttonFalseText: '申訴客服'
        })) {
          if (!storageUtils.get(`createWorkOrderTrackingNo${params.trackingNo}`)) {
            const res = await this.$store.dispatch('comment/createWorkOrder', {
              ignoreLimit: '1',
              upyunFiles: [],
              content: `${params.trackingNo} 是我的包裹，但被其他帳號登記`
            })
            if (!res.data.error) {
              this.$snackbar('已提交申訴', { color: 'success' })
              storageUtils.set(`createWorkOrderTrackingNo${params.trackingNo}`, 60 * 24)
            }
          }
        }
      } else if (res.data.error === 'OidExists') {
        if (await this.$confirm(`${params.trackingNo} 包裹已打包`, {
          buttonTrueText: res.data.extras.oid ? '查看訂單' : '申訴客服'
        })) {
          if (res.data.extras.oid) {
            this.$store.commit('order/setShowOrderDialogData', { oid: res.data.extras.oid })
          } else {
            if (!storageUtils.get(`createWorkOrderTrackingNo${params.trackingNo}`)) {
              const res = await this.$store.dispatch('comment/createWorkOrder', {
                ignoreLimit: '1',
                upyunFiles: [],
                content: `${params.trackingNo} 是我的包裹，但被其他帳號打包`
              })
              if (!res.data.error) {
                this.$snackbar('已提交申訴', { color: 'success' })
                storageUtils.set(`createWorkOrderTrackingNo${params.trackingNo}`, 60 * 24)
              }
            }
          }
        }
      } else {
        this.$snackbar(res.data.error)
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.dialog-conente-scroll {
  max-height: calc(90vh - 108px);
}
</style>
